import fetchServer from "../../../fetchServer";

/** Approve quote on behalf of agent — only RefundQuoted + immediateRefund. */
export default async function approveRefundQuote(id) {
  var result = {
    return: 0,
    msg: "Failed approving quote",
    data: [],
  };

  await fetchServer({
    method: "PATCH",
    url: `/product/v1/refund/approveQuote/${id}`,
  })
    .then((res) => {
      if (res) {
        if (res.status === 200) {
          result = { return: 1, msg: "Successful", data: res.data.data };
        } else if (res?.data?.error) result["msg"] = res.data.error;
      }
    })
    .catch((err) => {
      console.log(err.message, err);
      if (err.message === "Network Error!") {
        result["msg"] = "Network Error!";
        result["error"] = "Please check your connection.";
      }
    });

  return result;
}
